import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';

export default function LanguageCard({ language, wordCount }) {
    const live = language.status === 'live';
    const dual = language.display_flag_mode === 'dual' && language.secondary_flag_emoji;
    const disabled = !live;
    const inner = (
        <div
            className={`group relative flex flex-col rounded-2xl border-2 p-5 transition-all ${
                live
                    ? 'border-lq-ink-100 bg-white hover:border-lq-purple-300 hover:shadow-lg hover:-translate-y-0.5'
                    : 'border-dashed border-lq-ink-300 bg-lq-ink-100/40'
            }`}
            data-testid={`language-card-${language.slug}`}
        >
            <div className="flex items-center gap-2 text-4xl mb-3" aria-hidden="true">
                <span>{language.primary_flag_emoji}</span>
                {dual && <span className="text-2xl opacity-80">{language.secondary_flag_emoji}</span>}
            </div>
            <div className="flex items-baseline gap-2">
                <h3 className="font-display text-xl font-semibold text-lq-ink-900">{language.name}</h3>
                {language.free_tier_unlock && live && (
                    <span className="text-[10px] font-bold uppercase tracking-widest text-lq-peach-600 bg-lq-peach-100 px-2 py-0.5 rounded-full">Free</span>
                )}
            </div>
            {live ? (
                <p className="mt-1 text-sm text-lq-ink-500">
                    Multiple puzzle types · all age tiers
                </p>
            ) : (
                <p className="mt-1 text-sm text-lq-ink-500 inline-flex items-center gap-1">
                    <Lock size={12} /> Coming soon
                </p>
            )}
        </div>
    );
    if (disabled) return inner;
    return (
        <Link to={`/languages/${language.slug}`} className="block" data-testid={`language-card-link-${language.slug}`}>
            {inner}
        </Link>
    );
}
